import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./App.jsx";
import {ErrorBoundaryApp} from "./components/ErrorBoundaryHandler/ErrorBoundaryApp";
import "./Infra/lang/index.js";
import "./index.css";
import {injectColorsAsCSSVars} from "./styles/colors.js";

// Inject legacy color vars until Phase 6 purge — design tokens live in index.css @theme.
injectColorsAsCSSVars();

// Silence unhandled rejections originating from browser extensions (e.g. MetaMask
// inpage.js) so they don't trigger Bun's dev error overlay during development.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", event => {
    const reason = event.reason;
    const stack = typeof reason?.stack === "string" ? reason.stack : "";
    const message = typeof reason?.message === "string" ? reason.message : String(reason ?? "");
    const fromExtension = stack.includes("chrome-extension://") || stack.includes("moz-extension://");
    const fromMetaMask = message.includes("MetaMask") || message.includes("inpage");
    if (fromExtension || fromMetaMask) {
      event.preventDefault();
    }
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in document");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundaryApp>
      <App />
    </ErrorBoundaryApp>
  </StrictMode>
);
